import { bl_fi_xtn_generic_doc_hdr_driver_link_RowClass, bl_fi_xtn_generic_doc_hdr_driver_link_RowInterface } from "../../dbschema/bl_fi_xtn_generic_doc_hdr_driver_link.model";
import { BaseContainerModel } from "../base-container.model";

export class ExternalGenDocHdrDriverLinkContainerModel extends BaseContainerModel{
    bl_fi_xtn_generic_doc_hdr_driver_link: bl_fi_xtn_generic_doc_hdr_driver_link_RowInterface = new bl_fi_xtn_generic_doc_hdr_driver_link_RowClass();
}
